import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandName";

export default function AboutSection() {
  return (
    <section
      data-testid="about-section"
      className="py-20 sm:py-28 lg:py-36 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Image */}
          <div className="overflow-hidden">
            <img
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_padel-shop-4/artifacts/dbwf9cba_espresso-back.png"
              alt="Padlr Performance Wear"
              className="w-full h-[400px] lg:h-[600px] object-cover"
            />
          </div>

          {/* Text */}
          <div>
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#8B6F47] mb-4" style={{ fontStyle: "normal" }}>
              Our Story
            </p>
            <h2
              data-testid="about-heading"
              className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[0.95] text-white mb-8"
            >
              Better Than{" "}
              <br />
              Yesterday
            </h2>
            <div className="space-y-5 text-white/40 leading-relaxed tracking-wide text-sm sm:text-base">
              <p>
                <BrandLogo color="rgba(255,255,255,0.4)" /> is for the ones who show up every day and push to be better —
                not just on the court, but in every part of life. That mindset is what
                drives everything we build.
              </p>
              <p>
                Top-quality technical fabrics for the court. Premium lifestyle pieces for
                the street. Two lines, one philosophy: be better than yesterday.
              </p>
            </div>
            <Link
              to="/about"
              data-testid="about-cta"
              className="inline-block mt-10 border border-white/20 text-white px-10 py-4 text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-[#0A0A0A] transition-all duration-300 active:scale-95"
              style={{ fontStyle: "normal" }}
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
